'use strict';

import { graphql } from 'react-relay/legacy.js';

export const sbRespRoot = graphql`
    query sbRespRootQuery(
        $userId: String = ""
        $personalizationId: String = ""
        $guestId: String = ""
        $fetchUser: Boolean!
        $uriRef: String = ""
        $originalUrl: String = ""
        $first: Int!
        $page: Int!
        $localeOrigin: String = ""
        $isTrade: Boolean!
        $showSeller: Boolean!
        $followSearchPages: [String]
        $followSearchTypes: [types] = [SEARCH, USER_PREFERENCE]
        $contentModuleId: String = ""
        $previewId: String = ""
        $regions: String = ""
        $userZipCode: String = ""
        $userCountryCode: String = ""
        $fetchRegionalInfo: Boolean = false
        $isClient: Boolean!
        $fetchSb: Boolean!
        $disableForceFacet: Boolean = false
        $disableNonParameterizedUrlRedirects: Boolean = false # Only used for static SB
        $fetchTileVideo: Boolean = false
        $interiorPhotosCount: Int = 10
        $marketTrendsUrl: String = ""
        $priceBookName: String
        $includeSponsoredItems: Boolean = false
        $regionsList: [String]
        $userHasConfirmedOrders: Boolean = false
        $pageDisplayEnum: PageDisplayEnum = searchAndBrowse
        $numOfItemsToInflate: Int
    ) {
        viewer {
            ...SbRespLayout_viewer
            ...detectPageExistsAndRedirect_viewer
        }
    }
`;
